import {env} from "../env/env";

export function getExistingToken(): Promise<Response>{
  return fetch(`${env.basePath}/menu/memberV2.do?type=auth-token`);
}

export function logout(): Promise<Response> {
  return fetch(`${env.basePath}/menu/logoff.do`)
}

export function login(email: string, password: string): Promise<Response> {
  const data = new URLSearchParams();
  data.append("data", JSON.stringify({email, password}));
  return fetch(`${env.basePath}/app/member/account/authenticate/sso/auth`, {
    method: 'post',
    body: data,
  })
}
